// Contact.jsx - Modernized Contact Page
import React, { useState } from 'react';
import { TextField, Button, Alert, ThemeProvider, createTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import './Contact.css';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#344E41',
    },
  },
});

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    fontFamily: "'Yekan Bakh FaNum Bold', sans-serif",
    transition: 'all 0.3s ease',
    '& fieldset': {
      borderColor: '#e0e0e0',
    },
    '&:hover fieldset': {
      borderColor: '#95A176',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#344E41',
    },
  },
  '& .MuiInputLabel-root': {
    fontFamily: "'Yekan Bakh FaNum Bold', sans-serif",
    right: 20,
    left: 'auto',
    transformOrigin: 'right',
  },
  '& .MuiInputBase-input': {
    fontFamily: "'Yekan Bakh FaNum Bold', sans-serif",
    textAlign: 'right',
    padding: '14px',
  },
});

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setError('لطفاً تمام فیلدهای الزامی را پر کنید');
      return;
    }
    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', subject: '', message: '' });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="contact-page">
        {/* Background Decor */}
        <div className="contact-bg-pattern"></div>
        
        <div className="contact-wrapper animate-fade-up">
          <div className="contact-container">
            
            {/* Left Side: Info Panel */}
            <div className="contact-info-panel">
              <div className="info-overlay"></div>
              <div className="info-content">
                <h2 className="info-title">راه‌های ارتباطی</h2>
                <p className="info-description">
                  تیم پشتیبانی فنی ما آماده پاسخگویی به سوالات شما در زمینه پایش ماهواره‌ای و تحلیل داده‌های GIS است.
                </p>

                <div className="info-details">
                  <div className="info-item">
                    <span className="info-icon">📍</span>
                    <div>
                      <h4>آدرس مرکزی</h4>
                      <p>تهران،خیابان انقلاب، خیابان وصال شیرازی، دانشکده جغرافیا دانشگاه تهران</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <span className="info-icon">📞</span>
                    <div>
                      <h4>تلفن تماس</h4>
                      <p dir="ltr">۰۲۱ - ۱۲۳۴ ۵۶۷۸</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <span className="info-icon">📧</span>
                    <div>
                      <h4>پست الکترونیک</h4>
                      <p>support@satagrysys.ir</p>
                    </div>
                  </div>
                </div>

                <div className="social-links">
                  <span>ما را دنبال کنید:</span>
                  <div className="social-icons">
                    <div className="s-icon">in</div>
                    <div className="s-icon">tg</div>
                    <div className="s-icon">ig</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Form */}
            <div className="contact-form-panel">
              <div className="form-header">
                <h1 className="form-title">ارسال پیام</h1>
                <p>پیشنهادات و سوالات خود را با ما در میان بگذارید</p>
              </div>

              <form onSubmit={handleSubmit} className="contact-main-form">
                {submitted && (
                  <Alert severity="success" className="contact-alert">
                    پیام شما با موفقیت دریافت شد.
                  </Alert>
                )}
                {error && (
                  <Alert severity="error" className="contact-alert">
                    {error}
                  </Alert>
                )}

                <div className="form-grid">
                  <StyledTextField
                    fullWidth
                    label="نام و نام خانوادگی"
                    value={formData.name}
                    onChange={handleChange('name')}
                    variant="outlined"
                    required
                  />
                  <StyledTextField
                    fullWidth
                    label="ایمیل"
                    type="email"
                    value={formData.email}
                    onChange={handleChange('email')}
                    variant="outlined"
                    required
                  />
                </div>

                <StyledTextField
                  fullWidth
                  label="موضوع پیام"
                  value={formData.subject}
                  onChange={handleChange('subject')}
                  variant="outlined"
                  className="full-span"
                />

                <StyledTextField
                  fullWidth
                  label="متن پیام شما"
                  value={formData.message}
                  onChange={handleChange('message')}
                  variant="outlined"
                  multiline
                  rows={5}
                  required
                  className="full-span"
                />

                <button type="submit" className="contact-submit-btn">
                  <span>ارسال اطلاعات</span>
                  <span className="btn-arrow">←</span>
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Contact;